import { authenticateCode } from './AuthAPI';

export const authService = {
  async authenticate(code) {
    try {
      await authenticateCode(code);
    } catch (error) {
      console.log('Failed authentication');
      throw Error(error);
    }
  },

  signout(callback) {
    this.resetSession();
    sessionStorage.clear();
    callback();
  },

  resetSession() {
    this.deleteAllCookies();
  },

  deleteAllCookies() {
    const cookies = document.cookie.split(';');

    for (var i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    }
  }
};
